import { ActivatedRoute, CanActivateFn, Router } from '@angular/router';
import { combineLatest, filter, map, take } from 'rxjs';

import { AuthService } from '@user/services/auth.service';
import { inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';

export const authGuard: CanActivateFn = () => {
    const auth = inject(AuthService);
    const router = inject(Router);
    const activatedRoute = inject(ActivatedRoute);

    // Convert signals to Observables
    const isInitialized$ = toObservable(auth.isInitialized);
    const isLoggedIn$ = toObservable(auth.isLoggedIn);

    return combineLatest([isInitialized$, isLoggedIn$, activatedRoute.url]).pipe(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        filter(([isInitialized, isLoggedIn, data]) => isInitialized),
        take(1),
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        map(([isInitialized, loggedIn, data]) => {
            if (!loggedIn) {
                router.navigate(['/sign-in']);
                return false;
            }
            return true;
        }),
    );
};
